module.exports = __webpack_public_path__ + "img/32.b1d3b823.png";